var inject = ['$scope']
export default class NavCtrl {

    constructor($scope) {
        this.$scope = $scope;
        $scope.navigation = [];
        $scope.navigation[0] = '';
        $scope.navigation[1] = '';
        $scope.navigation[2] = '';
        $scope.navigation[3] = '';

        var key = 0;
        var link = window.location.hash;

        console.log(key, link);
        switch (link) {
            case '#home':
                key = 0;
                break;
            case '#about':
                key = 1;
                break;
            case '#price':
                key = 2;
                break;
            case '#contact':
                key = 3;
                break;
            default:
                key = 0;
                link = '#home';
                break;

        }
        console.log(key, link);
        this.open(link, key)
    }

    open(link, key) {
        for (var i = 0; i < this.$scope.navigation.length; i++) {
            if (i != key) {
                this.$scope.navigation[i] = '';
            } else {
                this.$scope.navigation[i] = 'active';
            }
        }

        setTimeout(function () {
            window.location = link;
        }, 1500)
    }
}

NavCtrl.$inject = inject;


// WEBPACK FOOTER //
// ./src/app/modules/navigation/NavCtrl.js